// Mock data for NLP Coach, Reiki, and Akashic landing page

export const services = [
  {
    id: 1,
    title: "NLP Coaching",
    description: "Transform your mindset and achieve breakthrough results with Neuro-Linguistic Programming techniques tailored to your goals.",
    features: [
      "Overcome limiting beliefs",
      "Master communication skills",
      "Achieve personal & professional goals",
      "Build lasting confidence"
    ],
    icon: "brain",
    accentColor: "purple",
    duration: "60-90 min sessions",
    price: 5000
  },
  {
    id: 2,
    title: "Reiki Healing",
    description: "Experience deep relaxation and energy balance through ancient Japanese healing techniques that promote physical and emotional wellness.",
    features: [
      "Stress & anxiety relief",
      "Energy balance & alignment",
      "Physical healing support",
      "Emotional release"
    ],
    icon: "sparkles",
    accentColor: "blue",
    duration: "45-60 min sessions",
    price: 5000
  },
  {
    id: 3,
    title: "Akashic Records",
    description: "Access divine wisdom and guidance through your soul's eternal records to gain clarity on life purpose, relationships, and spiritual growth.",
    features: [
      "Soul purpose discovery",
      "Past life insights",
      "Relationship guidance",
      "Spiritual awakening"
    ],
    icon: "book-open",
    accentColor: "orange",
    duration: "60 min readings",
    price: 8000
  },
  {
    id: 4,
    title: "Relationship Workshop & Counselling for Women",
    description: "A safe, empowering space crafted exclusively for women to heal emotional wounds, reclaim self-worth, and build the relationships they truly deserve. Through guided introspection, NLP-based reframing, and energy healing, you'll uncover patterns that keep you stuck — in love, family, or partnerships — and learn the inner skills to set boundaries, communicate from strength, and attract aligned, respectful love.",
    features: [
      "Heal past emotional wounds & breakups",
      "Rebuild self-worth and confidence",
      "Set healthy boundaries with clarity",
      "Attract aligned, respectful partnerships"
    ],
    icon: "heart",
    accentColor: "purple",
    duration: "90 min sessions / group workshops",
    price: 5000
  },
  {
    id: 5,
    title: "Relationship Workshop & Counselling for Men",
    description: "A judgement-free zone for men to decode emotions, communication, and intimacy without losing their authentic masculine essence. We work on emotional intelligence, anger and stress patterns, attachment styles, and the unspoken pressures that show up in romantic, family, and professional relationships — so you can lead, love, and connect with confidence and depth.",
    features: [
      "Emotional intelligence & expression",
      "Master healthy communication",
      "Heal anger, stress & attachment patterns",
      "Lead relationships with confidence"
    ],
    icon: "user-check",
    accentColor: "blue",
    duration: "90 min sessions / group workshops",
    price: 5000
  },
  {
    id: 6,
    title: "Pre-Marital Compatibility Counselling",
    description: "Before you say 'I do', understand who you're really saying it to. This deep-dive counselling helps couples (and individuals evaluating a prospect) assess emotional, psychological, financial, lifestyle, and spiritual compatibility. Through structured conversations, personality mapping, and Akashic insights, we surface red flags, green flags, and the real conversations every couple must have before marriage — so you walk in clear, aligned, and confident.",
    features: [
      "Compatibility assessment across 7 life areas",
      "Surface deal-breakers & green flags early",
      "Navigate family, finance & lifestyle alignment",
      "Optional Akashic soul-match insight"
    ],
    icon: "heart-handshake",
    accentColor: "orange",
    duration: "2-3 sessions of 75 min each",
    price: 5000
  },
  {
    id: 7,
    title: "Counselling for Pain in Any Relationship",
    description: "Whether it's a partner, parent, child, sibling, friend, or colleague — unresolved relationship pain quietly drains your peace, health, and growth. This service offers compassionate, structured support to process betrayal, grief, conflict, neglect, or estrangement. Using NLP, Reiki, and Akashic guidance, we release the emotional charge, reframe the story, and help you reclaim your power — whether you choose to repair, redefine, or release the relationship.",
    features: [
      "Process betrayal, grief & conflict",
      "Release emotional charge & resentment",
      "Reframe painful narratives",
      "Decide to repair, redefine, or release"
    ],
    icon: "heart-crack",
    accentColor: "purple",
    duration: "60-90 min sessions",
    price: 5000
  },
  {
    id: 8,
    title: "Live-In Relationship Counselling — Pain & Pleasure",
    description: "Live-in relationships offer freedom and intimacy, but also unique pressures — societal judgement, blurred expectations, family conflict, intimacy concerns, and the 'what next?' question. This judgement-free counselling helps individuals and couples in live-in setups navigate the highs and lows: from communication and finances to intimacy, exclusivity, and long-term vision — so your relationship becomes conscious, joyful, and truly aligned.",
    features: [
      "Clarify expectations & long-term vision",
      "Navigate intimacy, finances & space",
      "Handle societal & family pressures",
      "Build conscious, joyful togetherness"
    ],
    icon: "flame",
    accentColor: "blue",
    duration: "60-90 min sessions",
    price: 5000
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Entrepreneur",
    content: "The NLP coaching completely transformed how I approach challenges. I've achieved more in 3 months than I did in 3 years.",
    rating: 5
  },
  {
    id: 2,
    name: "David Chen",
    role: "Corporate Executive",
    content: "Reiki sessions have become essential for my wellbeing. The energy shifts are profound and the stress relief is incredible.",
    rating: 5
  },
  {
    id: 3,
    name: "Emma Rodriguez",
    role: "Wellness Coach",
    content: "The Akashic Records reading gave me clarity I'd been seeking for years. It was deeply transformative and accurate.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What can I expect in my first session?",
    answer: "Your first session begins with a consultation to understand your needs and goals. We'll discuss which modality best serves you and create a personalized approach. Sessions are conducted in a safe, supportive environment either in-person or virtually."
  },
  {
    id: 2,
    question: "How do I know which service is right for me?",
    answer: "NLP Coaching is ideal for goal achievement and mindset transformation. Reiki is perfect for stress relief and energy healing. Akashic Records are best for spiritual guidance and life purpose clarity. During consultation, I'll help you choose the right path."
  },
  {
    id: 3,
    question: "Are sessions available online or in-person?",
    answer: "Both! I offer flexible scheduling with in-person sessions at my healing space and virtual sessions via secure video call. Energy healing and readings are equally effective remotely."
  },
  {
    id: 4,
    question: "How many sessions will I need?",
    answer: "This varies by individual and goals. Some clients experience breakthroughs in a single session, while others prefer ongoing support. After our initial session, I'll recommend a personalized plan that serves your highest good."
  },
  {
    id: 5,
    question: "What should I do to prepare for a session?",
    answer: "Come with an open mind and heart. For Reiki, wear comfortable clothing. For NLP, bring specific goals you want to work on. For Akashic Records, prepare questions about your life path. Detailed preparation guidance is sent after booking."
  }
];

export const benefits = [
  {
    id: 1,
    title: "Personalized Approach",
    description: "Every session is tailored to your unique needs, goals, and spiritual journey.",
    icon: "user"
  },
  {
    id: 2,
    title: "Certified Expertise",
    description: "Trained and certified in NLP, Reiki Master level, and Akashic Records reading.",
    icon: "award"
  },
  {
    id: 3,
    title: "Holistic Healing",
    description: "Addressing mind, body, and spirit for complete transformation and wellness.",
    icon: "heart"
  },
  {
    id: 4,
    title: "Proven Results",
    description: "Hundreds of clients have experienced profound shifts and lasting change.",
    icon: "trending-up"
  }
];
